import { axiosInstance } from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";

export type PixelEvent =
  | "ViewContent"
  | "AddToCart"
  | "InitiateCheckout"
  | "AddPaymentInfo"
  | "Purchase";

export type PixelConfig<EventName extends string = string> = {
  code: string;
  enabled_events: EventName[];
};

export type EventPixels = {
  facebook?: PixelConfig<PixelEvent>[];
  tiktok?: PixelConfig<PixelEvent>[];
  ga4?: PixelConfig[];
};

export function useEventPixels(eventSlug?: string) {
  return useQuery(
    ["pixels", eventSlug],
    () =>
      axiosInstance
        .get(`/api/events/${eventSlug}/pixels`)
        .then((response) => response.data as EventPixels),
    {
      enabled: Boolean(eventSlug),
      refetchOnWindowFocus: false,
    },
  );
}
